import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { isPortal, redirectToPortalHome } from 'vet-bones/utils/portal';

import { connectionActionCreators } from 'src/common/actions/connection/connectionActionCreators';
import { StudioThunkDispatch } from 'src/common/actions/StudioAction';
import {
  ConnectionFailureReason,
  DrawerStatus,
} from 'src/common/store/connection/ConnectionState';
import * as copy from 'src/common/templates/copy';
import { ReduxState } from 'src/types';

function mapStateToProps({ connection }: ReduxState) {
  const { current, drawer } = connection;
  const isOpen =
    current.failureReason === ConnectionFailureReason.BROWSER_AUTH_FAILED &&
    drawer.status === DrawerStatus.OPEN;

  return {
    isOpen,
  };
}

function mapDispatchToProps(dispatch: StudioThunkDispatch) {
  return {
    toggleAppDrawer: () => dispatch(connectionActionCreators.toggleAppDrawer()),
  };
}

type BrowserAuthFailedDialogStateProps = ReturnType<typeof mapStateToProps>;
type BrowserAuthFailedDialogDispatchProps = ReturnType<
  typeof mapDispatchToProps
>;
type BrowserAuthFailedDialogCombinedProps = BrowserAuthFailedDialogStateProps &
  BrowserAuthFailedDialogDispatchProps;

const UnconnectedBrowserAuthFailedDialog: React.VFC<BrowserAuthFailedDialogCombinedProps> =
  ({ isOpen, toggleAppDrawer }) => {
    const handleClose = () => {
      toggleAppDrawer();
    };

    const action = isPortal() ? (
      <Button
        icon={IconNames.HOME}
        intent={Intent.PRIMARY}
        onClick={() => {
          redirectToPortalHome(window);
        }}
        text={copy.components.browserAuthFailedDialog.homeButton}
      />
    ) : (
      <Button
        onClick={handleClose}
        text={copy.components.browserAuthFailedDialog.closeButton}
      />
    );

    return (
      <Dialog
        autoFocus={false}
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
        enforceFocus={false}
        icon={IconNames.INFO_SIGN}
        isCloseButtonShown={false}
        isOpen={isOpen}
        title={copy.components.browserAuthFailedDialog.title}
      >
        <div className={Classes.DIALOG_BODY}>
          {copy.components.browserAuthFailedDialog.message}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>{action}</div>
        </div>
      </Dialog>
    );
  };

export const BrowserAuthFailedDialog = connect<
  BrowserAuthFailedDialogStateProps,
  BrowserAuthFailedDialogDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps
)(UnconnectedBrowserAuthFailedDialog);
